import { axios } from '@/lib/axios';

interface GetAreaListRequestParams {
  project_category_id: number;
}

export const getAreaList = (params: GetAreaListRequestParams) => {
  return axios.get(`/api/v1/areas/getAreaList`, { params });
};